import api from '../api/api';
import SlotValueType from '../../types/BotBuilder/SlotValueType';

export interface SystemVariableDto {
  name: string;
  valueType: SlotValueType;
  description: string;
  category: string;
  example: string;
}

class SystemVariableService {
  static async getSystemVariables(): Promise<SystemVariableDto[]> {
    try {
      const response = await api.get('chatbots/system-variables');
      return response.data;
    } catch (error) {
      console.error('Failed to fetch system variables:', error);
      return [];
    }
  }
}

export default SystemVariableService;
